module.exports = __webpack_public_path__ + "static/media/default-picture4.44769958.svg";